module.exports = __webpack_public_path__ + "static/media/learningAgility-assessment.79d5eabe.png";